
import {
  GET_PRODUCT_DETAIL,
  GET_PRODUCT_LIST,
  UPDATE_LOADING_STATUS,
  GET_ALL_CATEGORY,
  SET_ADMIN,
} from "../actions/product";
// import { pageSize } from "../../../common/utils/index";

const defVal = {
  // 产品详情
  productDetail: {},
  productList: [],
  versionList:[],
  // 类目列表
  categoryList: [],
  // 按小类名称为key的类目信息对象
  categoryInfo: {},
  loading: true,
  current: 0,
  pageSize: 10,
  total: 0,
  // 是否为管理员账号
  isAdmin: false,
};

export default (state = defVal, action) => {
  switch (action.type) {
    case GET_PRODUCT_DETAIL:
      return Object.assign({}, state, {
        productDetail: action.productDetail,
      });
    case GET_PRODUCT_LIST:
      return Object.assign({}, state, {
        productList: action.productList,
        total: action.total,
        current: action.current,
        pageSize: action.pageSize,
      });

    case UPDATE_LOADING_STATUS:
      return Object.assign({}, state, {
        loading: action.loading
      });
    case GET_ALL_CATEGORY:
      return Object.assign({}, state, {
        categoryList: action.categoryList,
        categoryInfo: action.categoryInfo,
      });
    case SET_ADMIN:
      const changed = {}
      if(action.biz == 'admin'){
        changed.isAdmin = action.allowed;
      }
      return Object.assign({}, state, changed);
    default:
      return state;
  }
};
